<template>
  <div class="content-dashboard">
    <h3>Mes Documents</h3>

    <div class="list-button mt-4">
      <a href="#" @click.prevent="selectFilter(null)" :class="{ active: !documentStore.selectedDocumentType }">Tous</a>
      <a
        v-for="docType in documentTypes"
        :key="docType"
        href="#"
        @click.prevent="selectFilter(docType)"
        :class="{ active: documentStore.selectedDocumentType === docType }"
      >
        {{ docType }}
      </a>
    </div>
    <div v-if="loading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <template v-else>
      <template v-for="(category, index) in documentsFiltered" :key="index">
        <h4 class="mt-4 mb-4 font-15">
          {{ category.name }}
        </h4>
        <div class="row mb-5">
          <template v-for="file in category.documents" :key="file.id">
            <div class="col-lg-4 my-1">
              <div class="gray-box">
                <img :src="file.image?.path || document" />
                <div class="gray-box-info">
                  <p>{{ file.title }}</p>
                  <small class="text-muted">{{ file.typesAsString }}</small>
                  <br />
                  <a
                    href="#"
                    @click.prevent="downloadFile(file)"
                    class="btn btn-outline-orange mt-2"
                  >
                    <img :src="download" />
                    <span>Télécharger </span>
                  </a>
                </div>
              </div>
            </div>
          </template>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
  import document from "@/assets/images/document-duplication.svg";
  import download from "@/assets/images/download.svg";
  import { useDocumentStore } from "@/stores/documentStore";
  import { downloadDocument } from "@/api/auth";

  export default {
    name: "DocumentsView",
    data() {
      return {
        document,
        download,
      };
    },
    computed: {
      documentStore() {
        return useDocumentStore();
      },
      documentTypes() {
        return this.documentStore.DocumentTypes;
      },
      documentsFiltered() {
        return this.documentStore.FilteredDocuments;
      },
      loading() {
        return this.documentStore.loading;
      },
    },
    created() {
      const documentStore = useDocumentStore();
      documentStore.fetchListDocuments();
    },
    methods: {
      selectFilter(documentType) {
        if (documentType === null) {
          this.documentStore.clearDocumentTypeFilter();
        } else {
          this.documentStore.setDocumentTypeFilter(documentType);
        }
      },

      async downloadFile(file) {
        if (!file?.id) return;
        try {
          const response = await downloadDocument(file.id); 
          const blob = response.data;

        
          console.log('headers', response.headers)

          // Vérifie la casse ici :
          let disposition =
            response.headers["content-disposition"] ||
            response.headers["Content-Disposition"];
          console.log("Disposition header:", disposition);

          let fileName = "document";
          if (disposition && disposition.includes("filename=")) {
            const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (match && match[1]) {
              fileName = decodeURIComponent(match[1].replace(/['"]/g, ""));
            }
          }

          const url = window.URL.createObjectURL(blob);
          const link = window.document.createElement("a");
          link.href = url;
          link.download = fileName;
          window.document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);

          console.log("Nom du fichier final:", fileName);
        } catch (error) {
          console.error("Erreur lors du téléchargement:", error);
        }
      },
      getFileExtension(mimeType) {
        const mimeToExt = {
          "application/pdf": ".pdf",
          "application/msword": ".doc",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx",
          "application/vnd.ms-excel": ".xls",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
          "image/jpeg": ".jpg",
          "image/png": ".png",
          "text/plain": ".txt",
          "application/zip": ".zip",
          "application/octet-stream": ".pdf"
        };
        return mimeToExt[mimeType] || ".pdf";
      }
    },
  };
</script>
